import { Component, EventEmitter, Output } from '@angular/core';
import { DataManagementService } from 'src/app/pages/data-management/data-management.service';
import { HistoricalService } from 'src/app/pages/historical/historical.service';

@Component({
  selector: 'app-historique-info-bar',
  templateUrl: './historique-info-bar.component.html',
  styleUrls: ['./historique-info-bar.component.scss'],
})
export class HistoriqueInfoBarComponent {
  @Output() configClick = new EventEmitter<void>();

  constructor(
    public dataManagementService: DataManagementService,
    public historicalService: HistoricalService,
  ) {}
}
